import * as React from 'react';
import styled from 'styled-components';

import colors from '../../colors';

export default class Footer extends React.Component {
    public render() {
        return (
            <Wrapper>
                <div>
                    <Emphasis>Conversations</Emphasis> is engineered by{' '}
                    <A
                        target="blank"
                        href="https://www.dealerinspire.com/conversations-live-chat-messaging-platform-with-ai/?utm_source=cars-embed"
                    >
                        Dealer Inspire
                    </A>
                </div>
            </Wrapper>
        );
    }
}

const Wrapper = styled.div`
    background-color: ${colors.carsGray};
    color: white;
    font-size: 12px;
    text-align: right;
    padding: 10px;
    margin: 2em -20px 0 -20px;
    margin-left: -20px;
    margin-right: -20px;
    z-index: 5;
    font-weight: 300;
`;

const A = styled.a`
    color: white;
    text-decoration: none;
    &:hover,
    &:focus {
        color: white;
        text-decoration: underline;
    }
`;

const Emphasis = styled.span`font-weight: 600;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Cars/Footer.tsx